"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var i18n_1 = require("../../i18n");
var FormsStore_1 = require("./../../data/FormsStore");
var s = require("./PayButton.scss");
var Loader_1 = require("./../../components/Loader");
var Translate_1 = require("./../../components/Translate");
var MANDATORY_FIELDS_FORM = 'MANDATORY_FIELDS_FORM';
// TODO we should move this to separate repo
var PAY_BAD_STATUSES = ['UNDEFINED', 'DECLINED', 'FAILED', 'BUYER_CANCELED', 'TIMEOUT'];
var PENDING_STATUSES = ['IN_PROCESS', 'INITIALIZATION'];
var PayButton = (function (_super) {
    __extends(PayButton, _super);
    function PayButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComponentMounted = false;
        _this.state = {
            loading: true,
            disabled: false,
            error: false,
        };
        _this.safeSetState = function (state) {
            if (_this.isComponentMounted) {
                _this.setState(state);
            }
        };
        _this.logValidationStatus = function (isValid, validateResult) {
            var invalidFields = [];
            if (!isValid) {
                var formData_1 = FormsStore_1.default.getFormData(MANDATORY_FIELDS_FORM);
                invalidFields = Object.keys(formData_1)
                    .filter(function (field) { return !formData_1[field].isValid; });
                invalidFields.push.apply(invalidFields, validateResult.invalidFields || []);
            }
            _this.props.paymentsSDK.logMandatoryFieldsValidationStatus({
                invalidFields: invalidFields,
                status: isValid,
                paymentMethod: _this.props.paymentMethod.paymentMethod,
                paymentProvider: _this.props.paymentMethod.connectedProviderId,
                orderId: _this.props.orderId,
            });
        };
        _this.handlePay = function () { return __awaiter(_this, void 0, void 0, function () {
            var validateFormPromise, validateResult, isMandatoryFieldsValid, isValid, payResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validateFormPromise = this.props.paymentsSDK.validate(this.props.paymentMethod.paymentMethod);
                        this.safeSetState({
                            loading: true,
                            disabled: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, validateFormPromise];
                    case 2:
                        validateResult = _a.sent();
                        isMandatoryFieldsValid = !this.props.withMandatoryFields || this.props.validateForm();
                        isValid = validateResult.isValid && isMandatoryFieldsValid;
                        this.logValidationStatus(isValid, validateResult);
                        if (!isValid) return [3 /*break*/, 4];
                        if (this.props.onPayStart) {
                            this.props.onPayStart(this.props.paymentMethod);
                        }
                        return [4 /*yield*/, this.props.paymentsSDK.pay(this.props.paymentMethod.paymentMethod)];
                    case 3:
                        payResult = _a.sent();
                        if (PAY_BAD_STATUSES.indexOf(payResult.status) !== -1) {
                            this.safeSetState({
                                loading: false,
                                disabled: false,
                                error: true,
                            });
                            throw new Error('Bad transaction');
                        }
                        else if (PENDING_STATUSES.indexOf(payResult.status) !== -1) {
                            this.safeSetState({
                                loading: true,
                                disabled: true,
                                error: false,
                            });
                        }
                        else {
                            this.safeSetState({
                                loading: false,
                                disabled: false,
                                error: false,
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4: throw new Error('Invalid form');
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        this.safeSetState({
                            loading: false,
                            disabled: false,
                            error: true,
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    PayButton.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isComponentMounted = true;
                        return [4 /*yield*/, i18n_1.init({ locale: this.props.locale || 'en' })];
                    case 1:
                        _a.sent();
                        this.setState({ loading: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    PayButton.prototype.componentWillUnmount = function () {
        this.isComponentMounted = false;
    };
    PayButton.prototype.renderButtonContent = function () {
        if (this.state.loading) {
            return React.createElement("span", { className: s.spinnerWrap },
                React.createElement(Loader_1.default, { size: "small" }));
        }
        return React.createElement(Translate_1.default, { forKey: this.props.text });
    };
    PayButton.prototype.render = function () {
        return (React.createElement("button", { disabled: this.state.disabled, "data-hook": "cashier-payments-method-pay-button", className: s.root, onClick: this.handlePay }, this.renderButtonContent()));
    };
    PayButton.defaultProps = {
        withMandatoryFields: true,
        text: 'form.submit',
        validateForm: FormsStore_1.default.validate.bind(null, MANDATORY_FIELDS_FORM),
    };
    return PayButton;
}(React.Component));
exports.default = PayButton;
//# sourceMappingURL=PayButton.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/PayButton/PayButton.js
// module id = 217
// module chunks = 0 1